export default "__VITE_ASSET__DdnCZOSn__"